export enum SubmitReceiptBatchError {
  /** Service provider info incomplete */
  SERVICE_PROVIDER_INFO_INCOMPLETE = 'SERVICE_PROVIDER_INFO_INCOMPLETE',
  /** Service provider user info incomplete */
  SERVICE_PROVIDER_USER_INCOMPLETE = 'SERVICE_PROVIDER_USER_INCOMPLETE',
  /** Resident first or last name not set */
  RESIDENT_INFO_INCOMPLETE = 'RESIDENT_INFO_INCOMPLETE',
  /** Nursing home info incomplete */
  NURSING_HOME_INFO_INCOMPLETE = 'NURSING_HOME_INFO_INCOMPLETE',
  /** Service provider has not completed payment onboarding */
  SERVICE_PROVIDER_NOT_ONBOARDED = 'SERVICE_PROVIDER_NOT_ONBOARDED',
}
